/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupswindowlabel2Inputs */

const en_signupswindowlabel2 = /** @type {(inputs: Signupswindowlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time window`)
};

const de_signupswindowlabel2 = /** @type {(inputs: Signupswindowlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitraum`)
};

/**
* | output |
* | --- |
* | "Time window" |
*
* @param {Signupswindowlabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupswindowlabel2 = /** @type {((inputs?: Signupswindowlabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupswindowlabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupswindowlabel2(inputs)
	return de_signupswindowlabel2(inputs)
});
export { signupswindowlabel2 as "signupsWindowLabel" }